export default __webpack_public_path__ + "static/media/card3.6d664a9c.jpg";